import { memo, useMemo } from 'react';
import {
  Bookmark,
  Box,
  Briefcase,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  ChevronsDown,
  ChevronsRight,
  ChevronsUp,
  Clipboard,
  CornerLeftUp,
  CornerRightDown,
  Download,
  Edit,
  ExternalLink,
  Eye,
  Filter,
  Grid,
  Menu,
  Minus,
  MoreHorizontal,
  Move,
  Plus,
  PlusSquare,
  Server,
  Settings,
  Trash2,
  Edit2,
  ChevronsLeft,
  ChevronRight,
  BookOpen,
} from 'react-feather';

import Copy from 'assets/img/icons/copy.svg';
import CopyBlue from 'assets/img/icons/copy_blue.svg';
import Library from 'assets/img/icons/library.svg';
import Prefill from 'assets/img/icons/paint.svg';
import Trash from 'assets/img/icons/trash.svg';
import MagicWind from 'assets/img/icons/magicWand.svg';

import { IconTypes } from 'components/types/parts/icon';

function Icon({ typeIcon, style, ...props }: IconTypes) {
  const memoIcon = useMemo(() => {
    switch (typeIcon) {
      case 'plus':
        return <Plus size={12} style={{ strokeWidth: '3', ...style }} />;
        break;
      case 'plusSquare':
        return (
          <PlusSquare size={16} style={{ strokeWidth: '2.5', ...style }} />
        );
        break;
      case 'minus':
        return <Minus size={16} style={{ strokeWidth: '4', ...style }} />;
        break;
      case 'menu':
        return <Menu size={14} style={{ strokeWidth: '3.5', ...style }} />;
        break;
      case 'grid':
        return <Grid size={18} style={{ ...style, strokeWidth: '2.5' }} />;
        break;
      case 'briefCase':
        return <Briefcase size={18} style={{ ...style, strokeWidth: '2.5' }} />;
        break;
      case 'box':
        return <Box size={19} style={{ ...style, strokeWidth: '2.5' }} />;
        break;
      case 'bookmark':
        return <Bookmark size={18} style={{ ...style, strokeWidth: '2.5' }} />;
        break;
      case 'clipboard':
        return <Clipboard size={18} style={{ ...style, strokeWidth: '2.5' }} />;
        break;
      case 'server':
        return <Server size={18} style={{ ...style, strokeWidth: '2.5' }} />;
        break;
      case 'setting':
        return <Settings size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;
      case 'option':
        return (
          <MoreHorizontal size={24} style={{ ...style, strokeWidth: '2.5' }} />
        );
        break;
      case 'down':
        return (
          <ChevronDown size={18} style={{ ...style, strokeWidth: '1.5' }} />
        );
        break;
      case 'up':
        return (
          <ChevronUp size={18} style={{ ...style, strokeWidth: '1.5' }} {...props} />
        );
        break;
      case 'rightDown':
        return (
          <CornerRightDown size={18} style={{ ...style, strokeWidth: '1.5' }} />
        );
        break;
      case 'leftUp':
        return (
          <CornerLeftUp size={18} style={{ ...style, strokeWidth: '1.5' }} />
        );
        break;
      case 'edit':
        return <Edit size={18} style={{ ...style, strokeWidth: '2.5' }} />;
      case 'edit2':
        return <Edit2 size={12} style={{ ...style, strokeWidth: '2.5' }} />;
      case 'eye':
        return <Eye size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;
      case 'move':
        return <Move size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;
      case 'plusSquare':
        return (
          <PlusSquare size={20} style={{ ...style, strokeWidth: '2' }} />
        );
      case 'chevronsUp':
        return <ChevronsUp size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;
      case 'chevronsDown':
        return (
          <ChevronsDown size={18} style={{ ...style, strokeWidth: '2' }} />
        );
        break;
      case 'chevronsRight':
        return (
          <ChevronsRight size={18} style={{ ...style, strokeWidth: '2' }} />
        );
      case 'chevronsLeft':
        return (
          <ChevronsLeft size={18} style={{ ...style, strokeWidth: '2' }} />
        );
      case 'addNext':
        return (
          <CornerRightDown size={18} style={{ ...style, strokeWidth: '2' }} />
        );
        break;
      case 'addPrev':
        return (
          <CornerLeftUp size={18} style={{ ...style, strokeWidth: '2' }} />
        );
        break;
      case 'import':
        return <Download size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;
      case 'export':
        return (
          <ExternalLink size={18} style={{ ...style, strokeWidth: '2' }} />
        );
        break;
      case 'filter':
        return <Filter size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;
      case 'delete':
        return <Trash2 size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;
      case 'check_circle':
        return <CheckCircle size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;
      case 'chevronRight':
        return <ChevronRight size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;
      case 'bookOpen':
        return <BookOpen size={18} style={{ ...style, strokeWidth: '2' }} />;
        break;

      case 'loading':
        return <i className="fa-regular fa-hourglass" style={{ ...style }} />;
        break;
      case 'print':
        return <i className="fa-solid fa-print" style={{ ...style }} />;
        break;

      case 'cat':
        return <img src={Prefill} style={style} alt="prefill icon" />;
        break;
      case 'trash':
        return <img src={Trash} style={style} alt="trash icon" />;
        break;
      case 'copy':
        return <img src={Copy} style={style} alt="copy icon" />;
        break;
      case 'copy_blue':
        return <img src={CopyBlue} style={style} alt="copy icon" />;
        break;
      case 'library':
        return <img src={Library} style={style} alt="library icon" />;
        break;
      case 'magicWind':
        return <img src={MagicWind} style={style} alt="magic_wind icon" />;
        break;

      default:
        break;
    }
  }, [typeIcon, style]);
  return <>{memoIcon}</>;
}

export default memo(Icon);
